import React, { ReactNode } from 'react';
import { renderRich } from '../utils/richText';
type SectionProps = {
  id: string;
  number: string;
  title: string;
  subtitle?: string;
  children: ReactNode;
};
export function Section({
  id,
  number,
  title,
  subtitle,
  children
}: SectionProps) {
  return <section id={id} className="scroll-mt-16 border-b border-line py-12 md:py-[60px]" aria-labelledby={`${id}-title`} data-id="element-125" data-mp="3kvgkjx70kpyr">
      <div className="mx-auto max-w-[1080px] px-[22px]" data-id="element-126" data-mp="cf552dymym63">
        <h2 id={`${id}-title`} className="mb-2.5 text-[23px] font-extrabold leading-tight tracking-[-0.025em] text-fg md:text-[33px]" data-id="element-127" data-mp="chrhos0dvrv6">
          <span className="mr-2.5 align-super text-[0.5em] font-extrabold text-accent" data-id="element-128" data-mp="2p2cufzc9c8t">{number}</span>
          {title}
        </h2>
        {subtitle && <p className="mb-8 max-w-[820px] leading-relaxed text-muted" data-id="element-129" data-mp="vej06z83q2y6">{renderRich(subtitle)}</p>}
        {children}
      </div>
    </section>;
}